import Icon from '@components/v2/ui/Icon/Icon';
import Tooltip from '@components/v2/ui/Tooltip/Tooltip';
import { Box } from '@mui/material';
import { CircleAlert } from 'lucide-react';
import LangEnum from '../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../modules/translation/TranslationContext';
import { useObjectPendencies } from '../hooks/useObjectPendencies';

interface DetailsSectionPendencyAlertProps {
  sectionKey: string;
}

const DetailsSectionPendencyAlert = ({ sectionKey }: DetailsSectionPendencyAlertProps) => {
  const { translate } = useTranslation();
  const { countBySection } = useObjectPendencies();

  const quantity = countBySection(sectionKey);

  if (!quantity) {
    return null;
  }

  return (
    <Tooltip TooltipContent={translate(LangEnum.GLOBAL_PENDENCIES_COUNT, { quantity })}>
      <Box
        data-section-pendency-alert=""
        sx={{ display: 'inline-flex', flexShrink: 0, color: 'error.main' }}
      >
        <Icon icon={CircleAlert} size="md" />
      </Box>
    </Tooltip>
  );
};

export default DetailsSectionPendencyAlert;
